<template>
  <div
    class="h-screen flex w-full bg-img"
    :style="'background-image: url('+environment.login.background+');'"
    id="page-login"
  >
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-full md:w-full lg:w-3/4 xl:w-full mx-auto text-center p-2"
    >
      <h3 class="mb-6 text-4xl d-theme-heading-color">{{ $t('_pages.check_email_register.title') }}</h3>
      <p class="mb-6 text-2xl d-theme-text-inverse">{{ $t('_pages.check_email_register.subtitle') }}</p>

      <a
        v-if="mail_provider"
        v-bind:href="mail_provider.href"
        target="_blank"
        class="provider_mail mb-6"
      >
        <img :src="'/images/mail_logos/'+ mail_provider.icon" :alt="mail_provider.icon">
      </a>

      <div class="flex flex-wrap justify-between">
        <vs-button
          class="mr-4 hidden"
          @click="$router.push({name: 'loginPage', params: {partner: environment.id}})"
          type="border"
        >{{ $t('back') }}</vs-button>

        <vs-button
          class="mr-4 hidden"
          @click="$router.push({name: 'confirmRegister', params: {partner: environment.id}, query: getQuery()})"
          type="filled"
        >{{ $t('continue') }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import { environment } from "@/_helpers";

export default {
  data() {
    return {
      environment: environment(),
      mail_provider: false
    };
  },
  methods: {
    getQuery() {
      const params = this.$route.query;
      var q = {};
      if (typeof params["key"] != "undefined") {
        q["key"] = params["key"];
      }
      return q;
    }
  },
  mounted() {
    let provider = this.$route.params.type;
    if (typeof provider != "undefined") {
      switch (provider.toLowerCase().trim()) {
        case "outlook":
        case "hotmail":
        case "live":
        case "msn":
          this.mail_provider = {
            icon: "outlook.svg",
            href: "https://outlook.live.com/mail/inbox"
          };
          break;
        case "yahoo":
        case "ymail":
          this.mail_provider = {
            icon: "yahoo.svg",
            href: "https://login.yahoo.com"
          };
          break;
        case "gmail":
          this.mail_provider = {
            icon: "gmail.svg",
            href: "https://mail.google.com"
          };
          break;
        case "icloud":
          this.mail_provider = {
            icon: "icloud.png",
            href: "https://www.icloud.com/#mail"
          };
          break;
        case "terra":
          this.mail_provider = {
            icon: "terra.jpg",
            href: "https://mail.terra.com.br/"
          };
          break;
        case "uol":
          this.mail_provider = {
            icon: "uol.png",
            href: "https://email.uol.com.br/login/#"
          };
          break;
        default:
          this.mail_provider = false;
      }
    }
  }
};
</script>

<style lang="scss">
.provider_mail {
  width: 100px;
  & > img {
    max-width: 100px;
    max-height: 80px;
  }
}
</style>

